import { useRef } from "react";

export default function ExtrasNormal({
  titulo,
  loading,
  extrasBD,
  extrasQty,
  extrasSeleccionados,
  extrasTotal,
  incExtra,
  decExtra,
}) {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({
      left: -220,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({
      left: 220,
      behavior: "smooth",
    });
  };

  return (
    <div className="space-y-2">
      <p className="font-semibold">➕ {titulo}</p>

      {loading ? (
        <p className="text-gray-400 text-sm">Cargando adicionales...</p>
      ) : extrasBD.length === 0 ? (
        <p className="text-gray-400 text-sm">
          No hay adicionales para este producto
        </p>
      ) : (
        <div className="relative">
          {/* Scroll Left */}
          <button
            onClick={scrollLeft}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10
                     w-9 h-9 rounded-full
                     bg-black/70 hover:bg-black
                     text-white font-bold
                     flex items-center justify-center"
          >
            ‹
          </button>

          {/* Scroll Right */}
          <button
            onClick={scrollRight}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10
                     w-9 h-9 rounded-full
                     bg-black/70 hover:bg-black
                     text-white font-bold
                     flex items-center justify-center"
          >
            ›
          </button>

          <div
            ref={scrollRef}
            className="flex flex-nowrap gap-3 overflow-x-auto pb-3 px-10
                       scroll-smooth
                       scrollbar-thin
                       scrollbar-thumb-gray-400/50
                       scrollbar-track-transparent"
          >
            {extrasBD.map((e) => {
              const qty = extrasQty[e.id] || 0;

              return (
                <div
                  key={e.id}
                  className="min-w-[190px] flex-shrink-0
                             bg-[#0f0f0f]
                             border border-white/10
                             rounded-xl p-3"
                >
                  <p className="font-semibold text-sm">{e.nombre}</p>

                  <p className="text-orange-400 text-sm">
                    +${Number(e.precio).toLocaleString("es-CO")}
                  </p>

                  <div className="flex items-center gap-2 mt-3">
                    <button
                      onClick={() => decExtra(e.id)}
                      disabled={qty === 0}
                      className={`px-2 rounded text-white ${
                        qty === 0 ? "bg-gray-700" : "bg-red-500"
                      }`}
                    >
                      -
                    </button>

                    <span className="font-bold w-4 text-center">
                      {qty}
                    </span>

                    <button
                      onClick={() => incExtra(e.id)}
                      className="bg-green-500 px-2 rounded text-white"
                    >
                      +
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Resumen */}
      {extrasSeleccionados.length > 0 && (
        <div className="text-sm text-gray-300">
          <p className="font-semibold text-white">
            Extras elegidos:
          </p>

          <p>
            {extrasSeleccionados
              .map((x) =>
                x.qty > 1
                  ? `${x.nombre} x${x.qty}`
                  : x.nombre
              )
              .join(", ")}
          </p>

          <p className="text-orange-400 font-semibold">
            Extras: ${extrasTotal.toLocaleString("es-CO")}
          </p>
        </div>
      )}
    </div>
  );
}
